export default __webpack_public_path__ + "static/media/primary.f7ca1b9b4d101810c3ead9044089c8df.svg";